module.exports = __webpack_public_path__ + "img/1092.86dcb5a2.gif";